import { styled } from 'styled-components';

export default function TicketTitleArea() {
  return (
    <TitleWrapper>
      <TicketingTitle>
        2025 목포해상W쇼 <br />
        데크 관람석 입장권 예매
      </TicketingTitle>
      <SubTitle>
        예매자 정보 입력<span>입장권 수령받을 번호 입력</span>
      </SubTitle>
    </TitleWrapper>
  );
}

const TitleWrapper = styled.div`
  width: 100%;
  padding: 48px 48px 18px 48px;
`;

const TicketingTitle = styled.div`
  color: #111;
  font-family: 'GmarketSansBold';
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 128.571% */
  letter-spacing: -0.77px;
  margin-bottom: 20px;
`;

const SubTitle = styled.div`
  color: #111;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.45px;
  span {
    margin-left: 6px;

    color: #555;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.35px;
  }
`;
